export default __webpack_public_path__ + "static/media/VividLogoWithColour.88c71a55.svg";